import { render, staticRenderFns } from "./BookOneTime.vue?vue&type=template&id=4b52c136&scoped=true"
import script from "./BookOneTime.vue?vue&type=script&lang=js"
export * from "./BookOneTime.vue?vue&type=script&lang=js"
import style0 from "./BookOneTime.vue?vue&type=style&index=0&id=4b52c136&prod&lang=scss&scoped=true"
import style1 from "./BookOneTime.vue?vue&type=style&index=1&id=4b52c136&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b52c136",
  null
  
)

export default component.exports